var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 98,
    viewBox: "0 0 66 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9764 6.19394H40.9932H40.9764ZM40.9764 6.19394L34.0659 42.5015L59.1003 42.5857L25.0239 91.8061L31.9344 51.8619L6.90156 51.7747L40.9764 6.19394ZM40.9811 0.0690391C40.8157 0.0690391 40.6504 0.0750684 40.4881 0.0872227C39.407 0.1746 38.6903 0.535975 37.8406 1.10713C37.3621 1.42615 36.9307 1.81066 36.5589 2.24944C36.4473 2.38114 36.342 2.51808 36.2434 2.65982L1.92347 48.0813C0.568315 49.9387 0.369253 52.3903 1.4105 54.4391C2.45022 56.4879 4.55263 57.7864 6.85716 57.8033L24.537 57.9319L18.9785 90.6808C18.4503 93.4952 19.9509 96.3004 22.5923 97.4305C23.3599 97.7604 24.1868 97.9303 25.0223 97.9297C26.9471 97.9297 28.5288 97.0293 29.7157 95.4031L64.0784 46.1825C65.4336 44.325 65.6312 41.8704 64.5914 39.8247C63.5517 37.7759 61.4493 36.4773 59.1447 36.4605L41.4649 36.4299L46.9637 7.63475C47.0802 7.16333 47.1388 6.67946 47.1383 6.19385C47.1383 2.88022 44.4999 0.179098 41.1985 0.0719102C41.1251 0.0688477 41.053 0.0688477 40.9812 0.0688477L40.9811 0.0690391Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/flash.a04fa257b8588011269af264b1d7ac6f.svg";
export { ForwardRef as ReactComponent };